import { trimStringOrEmpty } from './spotName';

export type ButtonActionMode = 'book' | 'skip' | 'disabled';

export type ButtonActionModeContext = {
  bookingId: string;
  selectedSpot: { spotName: string } | null;
  layoutError: unknown;
  skipLoadingAvailable: boolean;
  bookSpotError: { message: string; message_code?: string } | null;
  hasBookableSpots: boolean | null;
  isInteractiveSpotBookingEnabled: boolean;
  isSkipInFlight: boolean;
};

export function isSkipOptionAvailable(
  context: Pick<
    ButtonActionModeContext,
    | 'layoutError'
    | 'skipLoadingAvailable'
    | 'bookSpotError'
    | 'hasBookableSpots'
    | 'isInteractiveSpotBookingEnabled'
  >
): boolean {
  const {
    layoutError,
    skipLoadingAvailable,
    bookSpotError,
    hasBookableSpots,
    isInteractiveSpotBookingEnabled
  } = context;

  return (
    layoutError != null ||
    skipLoadingAvailable ||
    bookSpotError != null ||
    (isInteractiveSpotBookingEnabled && hasBookableSpots === false)
  );
}

export function canBookSelectedSpot(context: ButtonActionModeContext): boolean {
  if (!context.selectedSpot) return false;
  if (trimStringOrEmpty(context.selectedSpot.spotName) === '') return false;
  if (!context.bookingId) return false;
  return context.hasBookableSpots !== false;
}

export function getButtonActionMode(context: ButtonActionModeContext): ButtonActionMode {
  if (context.isSkipInFlight) return 'skip';
  if (canBookSelectedSpot(context)) return 'book';
  if (
    isSkipOptionAvailable({
      layoutError: context.layoutError,
      skipLoadingAvailable: context.skipLoadingAvailable,
      bookSpotError: context.bookSpotError,
      hasBookableSpots: context.hasBookableSpots,
      isInteractiveSpotBookingEnabled: context.isInteractiveSpotBookingEnabled
    })
  ) {
    return 'skip';
  }
  return 'disabled';
}
